module.exports = __webpack_public_path__ + "static/img/信息发布系统.837ba64.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/images/信息发布系统.png
// module id = pSYx
// module chunks = 45